import { SuffixInterface } from "@/interface/app/filter.interface";
export class Suffix implements SuffixInterface {
  type: string = '';
  operand: string = '';
  selected: boolean = false

  constructor (data) {
      this.operand = data.operand
      this.type = data.type
      this.selected = data.selected || false
  }
}
